/**
 * Southbank Theme Main Front-end JavaScript Entrypoint
 * Compiled by Webpack to assets/build/js/main.js
 */

/**
 * Southbank Theme Main JavaScript
 * - Transparent Header on Scroll
 * - Mobile Menu Slide-out Drawer
 * - Hero Slider Carousel & Smooth Transitions
 * - Animated Rotating Script Text in Hero Description
 */

document.addEventListener('DOMContentLoaded', function () {
    // -------------------------------------------------------------
    // 1. Header Scroll Effect
    // -------------------------------------------------------------
    const header = document.getElementById('masthead');
    function handleHeaderScroll() {
        if (!header) return;
        if (window.scrollY > 40) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    }
    window.addEventListener('scroll', handleHeaderScroll, { passive: true });
    handleHeaderScroll();

    // -------------------------------------------------------------
    // 2. Mobile Drawer Navigation
    // -------------------------------------------------------------
    const mobileToggle   = document.getElementById('eg-mobile-toggle');
    const mobileDrawer   = document.getElementById('eg-mobile-drawer');
    const drawerClose    = document.getElementById('eg-drawer-close');
    const drawerBackdrop = document.getElementById('eg-drawer-backdrop');

    function openDrawer() {
        if (!mobileDrawer) return;
        mobileDrawer.classList.add('is-active');
        document.body.style.overflow = 'hidden';
        if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
        if (!mobileDrawer) return;
        mobileDrawer.classList.remove('is-active');
        document.body.style.overflow = '';
        if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    }

    if (mobileToggle) {
        mobileToggle.addEventListener('click', openDrawer);
    }
    if (drawerClose) {
        drawerClose.addEventListener('click', closeDrawer);
    }
    if (drawerBackdrop) {
        drawerBackdrop.addEventListener('click', closeDrawer);
    }
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('is-active')) {
            closeDrawer();
        }
    });

    // -------------------------------------------------------------
    // 3. Hero Slider Carousel & Animated Headline
    // -------------------------------------------------------------
    const sliderWrap = document.getElementById('eg-hero-slider');
    if (sliderWrap) {
        const slides        = sliderWrap.querySelectorAll('.eg-hero-slide');
        const prevBtn       = document.getElementById('eg-slider-prev');
        const nextBtn       = document.getElementById('eg-slider-next');
        const heroCard      = document.getElementById('eg-hero-card');
        const eyebrowEl     = document.getElementById('eg-hero-eyebrow');
        const titleEl       = document.getElementById('eg-hero-title');
        const descBeforeEl  = document.getElementById('eg-desc-before') || document.getElementById('eg-desc-prefix');
        const descAfterEl   = document.getElementById('eg-desc-after');
        const animatedWordEl= document.getElementById('eg-animated-word');

        if (slides.length) {
            let currentIndex     = 0;
            let autoplayTimer    = null;
            let wordRotateTimer  = null;
            let currentWordIndex = 0;

            const isAutoplay = sliderWrap.getAttribute('data-autoplay') === 'true';
            const slideDelay = parseInt(sliderWrap.getAttribute('data-delay'), 10) || 5500;

            // Helper to get active slide words
            function getCurrentSlideWords() {
                const activeSlide = slides[currentIndex];
                if (!activeSlide) return ['weddings - events.'];
                const rawJson = activeSlide.getAttribute('data-words');
                try {
                    const parsed = JSON.parse(rawJson);
                    if (Array.isArray(parsed) && parsed.length) return parsed;
                } catch (e) {
                    // fallback
                }
                return ['weddings - events.'];
            }

            // Animated Rotating Script Words loop
            function startWordRotation() {
                stopWordRotation();
                wordRotateTimer = setInterval(function () {
                    const words = getCurrentSlideWords();
                    if (words.length <= 1 || !animatedWordEl) return;

                    currentWordIndex = (currentWordIndex + 1) % words.length;
                    const nextWord = words[currentWordIndex];

                    // Trigger smooth transition
                    animatedWordEl.classList.add('is-transitioning');
                    setTimeout(function () {
                        animatedWordEl.textContent = nextWord;
                        animatedWordEl.classList.remove('is-transitioning');
                    }, 350);
                }, 2800);
            }

            function stopWordRotation() {
                if (wordRotateTimer) {
                    clearInterval(wordRotateTimer);
                    wordRotateTimer = null;
                }
            }

            function goToSlide(index) {
                if (index < 0) {
                    currentIndex = slides.length - 1;
                } else if (index >= slides.length) {
                    currentIndex = 0;
                } else {
                    currentIndex = index;
                }

                currentWordIndex = 0;

                // Animate card content transition
                if (heroCard) {
                    heroCard.classList.add('animating');
                }

                slides.forEach(function (slide, i) {
                    if (i === currentIndex) {
                        slide.classList.add('active');
                    } else {
                        slide.classList.remove('active');
                    }
                });

                const activeSlide   = slides[currentIndex];
                const newEyebrow    = activeSlide.getAttribute('data-eyebrow') || '';
                const newTitle      = activeSlide.getAttribute('data-title') || '';
                const newDescBefore = activeSlide.getAttribute('data-desc-before') || activeSlide.getAttribute('data-desc') || '';
                const newDescAfter  = activeSlide.getAttribute('data-desc-after') || '';
                const words         = getCurrentSlideWords();
                const initialWord   = words[0] || 'weddings - events.';

                setTimeout(function () {
                    if (eyebrowEl)      eyebrowEl.textContent      = newEyebrow;
                    if (titleEl)        titleEl.textContent        = newTitle;
                    if (descBeforeEl)   descBeforeEl.innerHTML   = newDescBefore;
                    if (descAfterEl)    descAfterEl.innerHTML    = newDescAfter;
                    if (animatedWordEl) animatedWordEl.textContent = initialWord;

                    if (heroCard) {
                        heroCard.classList.remove('animating');
                    }
                }, 220);

                startWordRotation();
            }

            function startAutoplay() {
                if (!isAutoplay || slides.length <= 1) return;
                stopAutoplay();
                autoplayTimer = setInterval(function () {
                    goToSlide(currentIndex + 1);
                }, slideDelay);
            }

            function stopAutoplay() {
                if (autoplayTimer) {
                    clearInterval(autoplayTimer);
                    autoplayTimer = null;
                }
            }

            if (prevBtn) {
                prevBtn.addEventListener('click', function () {
                    stopAutoplay();
                    goToSlide(currentIndex - 1);
                    startAutoplay();
                });
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', function () {
                    stopAutoplay();
                    goToSlide(currentIndex + 1);
                    startAutoplay();
                });
            }

            // Pause on hover
            sliderWrap.addEventListener('mouseenter', function () {
                stopAutoplay();
            });

            sliderWrap.addEventListener('mouseleave', function () {
                startAutoplay();
            });

            // Touch Swipe Navigation for Mobile
            let touchStartX = 0;
            let touchEndX = 0;

            sliderWrap.addEventListener('touchstart', function (e) {
                touchStartX = e.changedTouches[0].screenX;
            }, { passive: true });

            sliderWrap.addEventListener('touchend', function (e) {
                touchEndX = e.changedTouches[0].screenX;
                const diffX = touchEndX - touchStartX;
                if (Math.abs(diffX) > 45) {
                    stopAutoplay();
                    if (diffX < 0) {
                        goToSlide(currentIndex + 1);
                    } else {
                        goToSlide(currentIndex - 1);
                    }
                    startAutoplay();
                }
            }, { passive: true });

            // Initialize timers on load
            startAutoplay();
            startWordRotation();
        }
    }

    // -------------------------------------------------------------
    // 4. Explore Services Carousel & Pagination Dots
    // -------------------------------------------------------------
    const servicesSlider = document.getElementById('eg-services-slider');
    if (servicesSlider) {
        const track = document.getElementById('eg-services-track');
        const cards = servicesSlider.querySelectorAll('.eg-service-card-wrap');
        const dots  = servicesSlider.querySelectorAll('.eg-service-dot');
        let currentServicePage = 0;

        function getCardsPerPage() {
            if (window.innerWidth <= 768) return 1;
            if (window.innerWidth <= 1024) return 2;
            return 3;
        }

        function updateServicesSlider(pageIndex) {
            if (!track || !cards.length) return;
            const cardsPerPage = getCardsPerPage();
            const maxPages = Math.ceil(cards.length / cardsPerPage);

            if (pageIndex < 0) pageIndex = 0;
            if (pageIndex >= maxPages) pageIndex = maxPages - 1;

            currentServicePage = pageIndex;

            // Calculate shift constrained by max track scrollable width
            const cardWidth = cards[0].offsetWidth;
            const gap = 30;
            const maxShift = Math.max(0, track.scrollWidth - servicesSlider.clientWidth);
            let shift = currentServicePage * cardsPerPage * (cardWidth + gap);
            if (shift > maxShift) {
                shift = maxShift;
            }

            track.style.transform = 'translateX(-' + shift + 'px)';

            // Update active dot
            dots.forEach(function (dot, idx) {
                if (idx === currentServicePage) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }

        dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
                const targetPage = parseInt(this.getAttribute('data-page'), 10) || 0;
                updateServicesSlider(targetPage);
            });
        });

        // Touch swipe support for services
        let sTouchStartX = 0;
        let sTouchEndX = 0;

        servicesSlider.addEventListener('touchstart', function (e) {
            sTouchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        servicesSlider.addEventListener('touchend', function (e) {
            sTouchEndX = e.changedTouches[0].screenX;
            const sDiffX = sTouchEndX - sTouchStartX;
            if (Math.abs(sDiffX) > 40) {
                if (sDiffX < 0) {
                    updateServicesSlider(currentServicePage + 1);
                } else {
                    updateServicesSlider(currentServicePage - 1);
                }
            }
        }, { passive: true });

        window.addEventListener('resize', function () {
            updateServicesSlider(currentServicePage);
        }, { passive: true });
    }

    // -------------------------------------------------------------
    // 5. Testimonials Carousel Controller
    // -------------------------------------------------------------
    const testiSlider = document.getElementById('eg-testimonials-slider');
    if (testiSlider) {
        const tSlides = testiSlider.querySelectorAll('.eg-testimonial-slide');
        const tDots   = testiSlider.querySelectorAll('.eg-t-dot');
        if (tSlides.length > 1) {
            let currentTestiIndex = 0;
            let testiTimer = null;
            const isTestiAutoplay = testiSlider.getAttribute('data-autoplay') === 'true';
            const testiDelay = parseInt(testiSlider.getAttribute('data-delay'), 10) || 5500;

            function goToTestimonial(idx) {
                if (idx < 0) {
                    currentTestiIndex = tSlides.length - 1;
                } else if (idx >= tSlides.length) {
                    currentTestiIndex = 0;
                } else {
                    currentTestiIndex = idx;
                }

                tSlides.forEach(function (slide, i) {
                    if (i === currentTestiIndex) {
                        slide.classList.add('active');
                    } else {
                        slide.classList.remove('active');
                    }
                });

                tDots.forEach(function (dot, i) {
                    if (i === currentTestiIndex) {
                        dot.classList.add('active');
                    } else {
                        dot.classList.remove('active');
                    }
                });
            }

            function startTestiTimer() {
                if (!isTestiAutoplay) return;
                stopTestiTimer();
                testiTimer = setInterval(function () {
                    goToTestimonial(currentTestiIndex + 1);
                }, testiDelay);
            }

            function stopTestiTimer() {
                if (testiTimer) {
                    clearInterval(testiTimer);
                    testiTimer = null;
                }
            }

            tDots.forEach(function (dot) {
                dot.addEventListener('click', function () {
                    const targetIdx = parseInt(this.getAttribute('data-slide'), 10) || 0;
                    stopTestiTimer();
                    goToTestimonial(targetIdx);
                    startTestiTimer();
                });
            });

            testiSlider.addEventListener('mouseenter', stopTestiTimer);
            testiSlider.addEventListener('mouseleave', startTestiTimer);

            // Touch swipe
            let tTouchStartX = 0;
            let tTouchEndX = 0;
            testiSlider.addEventListener('touchstart', function (e) {
                tTouchStartX = e.changedTouches[0].screenX;
            }, { passive: true });

            testiSlider.addEventListener('touchend', function (e) {
                tTouchEndX = e.changedTouches[0].screenX;
                const diff = tTouchEndX - tTouchStartX;
                if (Math.abs(diff) > 40) {
                    stopTestiTimer();
                    if (diff < 0) {
                        goToTestimonial(currentTestiIndex + 1);
                    } else {
                        goToTestimonial(currentTestiIndex - 1);
                    }
                    startTestiTimer();
                }
            }, { passive: true });

            startTestiTimer();
        }
    }

    // -------------------------------------------------------------
    // 6. Portfolio 3D Flip Card Carousel Controller
    // -------------------------------------------------------------
    const portfolioSlider = document.getElementById('eg-portfolio-slider');
    if (portfolioSlider) {
        const pTrack = document.getElementById('eg-portfolio-track');
        const pCards = portfolioSlider.querySelectorAll('.eg-portfolio-card-wrap');
        const pDotsContainer = document.getElementById('eg-portfolio-dots');
        let currentPortfolioPage = 0;

        function getPortfolioCardsPerPage() {
            if (window.innerWidth <= 768) return 1;
            if (window.innerWidth <= 1024) return 2;
            if (document.body.classList.contains('eg-large-container') && window.innerWidth >= 1200) return 4;
            return 3;
        }

        function renderPortfolioDots() {
            if (!pDotsContainer || !pCards.length) return;
            const perPage = getPortfolioCardsPerPage();
            const totalPages = Math.ceil(pCards.length / perPage);

            pDotsContainer.innerHTML = '';
            if (totalPages <= 1) return;

            for (let i = 0; i < totalPages; i++) {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'eg-p-dot' + (i === currentPortfolioPage ? ' active' : '');
                dot.setAttribute('data-page', i);
                dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
                dot.addEventListener('click', function () {
                    const page = parseInt(this.getAttribute('data-page'), 10) || 0;
                    updatePortfolioSlider(page);
                });
                pDotsContainer.appendChild(dot);
            }
        }

        function updatePortfolioSlider(pageIndex) {
            if (!pTrack || !pCards.length) return;
            const perPage = getPortfolioCardsPerPage();
            const totalPages = Math.ceil(pCards.length / perPage);

            if (pageIndex < 0) pageIndex = 0;
            if (pageIndex >= totalPages) pageIndex = totalPages - 1;

            currentPortfolioPage = pageIndex;

            const cardWidth = pCards[0].offsetWidth;
            const gap = 30;
            const maxShift = Math.max(0, pTrack.scrollWidth - portfolioSlider.clientWidth);
            let shift = currentPortfolioPage * perPage * (cardWidth + gap);
            if (shift > maxShift) {
                shift = maxShift;
            }

            pTrack.style.transform = 'translateX(-' + shift + 'px)';

            const dots = pDotsContainer ? pDotsContainer.querySelectorAll('.eg-p-dot') : [];
            dots.forEach(function (dot, idx) {
                if (idx === currentPortfolioPage) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }

        // Initialize dots & position
        renderPortfolioDots();
        updatePortfolioSlider(0);

        // Touch swipe support
        let pTouchStartX = 0;
        let pTouchEndX = 0;

        portfolioSlider.addEventListener('touchstart', function (e) {
            pTouchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        portfolioSlider.addEventListener('touchend', function (e) {
            pTouchEndX = e.changedTouches[0].screenX;
            const diffX = pTouchEndX - pTouchStartX;
            if (Math.abs(diffX) > 40) {
                if (diffX < 0) {
                    updatePortfolioSlider(currentPortfolioPage + 1);
                } else {
                    updatePortfolioSlider(currentPortfolioPage - 1);
                }
            }
        }, { passive: true });

        window.addEventListener('resize', function () {
            renderPortfolioDots();
            updatePortfolioSlider(currentPortfolioPage);
        }, { passive: true });
    }

    // -------------------------------------------------------------
    // 7. Video Banner Modal Lightbox Controller
    // -------------------------------------------------------------
    const videoTrigger = document.getElementById('eg-video-play-trigger');
    const videoModal   = document.getElementById('eg-video-modal');
    const videoClose   = document.getElementById('eg-video-close-btn');
    const videoBackdrop= document.getElementById('eg-video-modal-close');
    const videoIframe  = document.getElementById('eg-video-iframe');

    function parseEmbedUrl(url) {
        if (!url) return '';
        // YouTube: watch?v=ID or youtu.be/ID
        let ytMatch = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]+)/);
        if (ytMatch && ytMatch[1]) {
            return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0&showinfo=0';
        }
        // Vimeo: vimeo.com/ID
        let vimMatch = url.match(/vimeo\.com\/(?:video\/)?([0-9]+)/);
        if (vimMatch && vimMatch[1]) {
            return 'https://player.vimeo.com/video/' + vimMatch[1] + '?autoplay=1';
        }
        return url;
    }

    function openVideoModal(url) {
        if (!videoModal || !videoIframe) return;
        const embedUrl = parseEmbedUrl(url);
        videoIframe.setAttribute('src', embedUrl);
        videoModal.classList.add('is-active');
        document.body.style.overflow = 'hidden';
    }

    function closeVideoModal() {
        if (!videoModal || !videoIframe) return;
        videoModal.classList.remove('is-active');
        videoIframe.setAttribute('src', '');
        document.body.style.overflow = '';
    }

    if (videoTrigger) {
        videoTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            const url = this.getAttribute('data-video-url') || this.getAttribute('href');
            openVideoModal(url);
        });
    }

    if (videoClose) {
        videoClose.addEventListener('click', closeVideoModal);
    }

    if (videoBackdrop) {
        videoBackdrop.addEventListener('click', closeVideoModal);
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && videoModal && videoModal.classList.contains('is-active')) {
            closeVideoModal();
        }
    });

    // -------------------------------------------------------------
    // 8. Pricing Plan Carousel Controller
    // -------------------------------------------------------------
    const pricingSlider = document.getElementById('eg-pricing-slider');
    if (pricingSlider) {
        const prSlides = pricingSlider.querySelectorAll('.eg-pricing-slide');
        const prDots   = pricingSlider.querySelectorAll('.eg-pr-dot');
        let currentPricingIndex = 0;

        function goToPricingSlide(index) {
            if (!prSlides.length) return;
            if (index < 0) {
                currentPricingIndex = prSlides.length - 1;
            } else if (index >= prSlides.length) {
                currentPricingIndex = 0;
            } else {
                currentPricingIndex = index;
            }

            prSlides.forEach(function (slide, i) {
                if (i === currentPricingIndex) {
                    slide.classList.add('active');
                } else {
                    slide.classList.remove('active');
                }
            });

            prDots.forEach(function (dot, i) {
                if (i === currentPricingIndex) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }

        prDots.forEach(function (dot) {
            dot.addEventListener('click', function () {
                const targetIdx = parseInt(this.getAttribute('data-slide'), 10) || 0;
                goToPricingSlide(targetIdx);
            });
        });

        // Touch swipe support
        let prTouchStartX = 0;
        let prTouchEndX = 0;

        pricingSlider.addEventListener('touchstart', function (e) {
            prTouchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        pricingSlider.addEventListener('touchend', function (e) {
            prTouchEndX = e.changedTouches[0].screenX;
            const diffX = prTouchEndX - prTouchStartX;
            if (Math.abs(diffX) > 40) {
                if (diffX < 0) {
                    goToPricingSlide(currentPricingIndex + 1);
                } else {
                    goToPricingSlide(currentPricingIndex - 1);
                }
            }
        }, { passive: true });
    }

    // -------------------------------------------------------------
    // 9. Wedding Blog Slider Controller (2 cards on desktop, 1 on mobile)
    // -------------------------------------------------------------
    const blogSlider = document.getElementById('eg-blog-slider');
    if (blogSlider) {
        const bTrack = document.getElementById('eg-blog-track');
        const bCards = blogSlider.querySelectorAll('.eg-blog-card-wrap');
        const bDotsContainer = document.getElementById('eg-blog-dots');
        let currentBlogPage = 0;

        function getBlogCardsPerPage() {
            if (window.innerWidth <= 768) return 1;
            if (document.body.classList.contains('eg-large-container') && window.innerWidth >= 1680) return 3;
            return 2;
        }

        function renderBlogDots() {
            if (!bDotsContainer || !bCards.length) return;
            const perPage = getBlogCardsPerPage();
            const totalPages = Math.ceil(bCards.length / perPage);

            bDotsContainer.innerHTML = '';
            if (totalPages <= 1) return;

            for (let i = 0; i < totalPages; i++) {
                const dot = document.createElement('button');
                dot.type = 'button';
                dot.className = 'eg-blog-dot' + (i === currentBlogPage ? ' active' : '');
                dot.setAttribute('data-page', i);
                dot.setAttribute('aria-label', 'Go to blog slide ' + (i + 1));
                dot.addEventListener('click', function () {
                    const page = parseInt(this.getAttribute('data-page'), 10) || 0;
                    updateBlogSlider(page);
                });
                bDotsContainer.appendChild(dot);
            }
        }

        function updateBlogSlider(pageIndex) {
            if (!bTrack || !bCards.length) return;
            const perPage = getBlogCardsPerPage();
            const totalPages = Math.ceil(bCards.length / perPage);

            if (pageIndex < 0) pageIndex = 0;
            if (pageIndex >= totalPages) pageIndex = totalPages - 1;

            currentBlogPage = pageIndex;

            const cardWidth = bCards[0].offsetWidth;
            const gap = 30;
            const maxShift = Math.max(0, bTrack.scrollWidth - blogSlider.clientWidth);
            let shift = currentBlogPage * perPage * (cardWidth + gap);
            if (shift > maxShift) {
                shift = maxShift;
            }

            bTrack.style.transform = 'translateX(-' + shift + 'px)';

            const dots = bDotsContainer ? bDotsContainer.querySelectorAll('.eg-blog-dot') : [];
            dots.forEach(function (dot, idx) {
                if (idx === currentBlogPage) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }

        // Initialize dots & position
        renderBlogDots();
        updateBlogSlider(0);

        // Touch swipe support
        let blogTouchStartX = 0;
        let blogTouchEndX = 0;

        blogSlider.addEventListener('touchstart', function (e) {
            blogTouchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        blogSlider.addEventListener('touchend', function (e) {
            blogTouchEndX = e.changedTouches[0].screenX;
            const diffX = blogTouchEndX - blogTouchStartX;
            if (Math.abs(diffX) > 40) {
                if (diffX < 0) {
                    updateBlogSlider(currentBlogPage + 1);
                } else {
                    updateBlogSlider(currentBlogPage - 1);
                }
            }
        }, { passive: true });

        window.addEventListener('resize', function () {
            renderBlogDots();
            updateBlogSlider(currentBlogPage);
        }, { passive: true });
    }

    // -------------------------------------------------------------
    // 10. Scroll To Top Button
    // -------------------------------------------------------------
    const scrollTopBtn = document.getElementById('eg-scroll-top');
    if (scrollTopBtn) {
        function toggleScrollTopBtn() {
            if (window.scrollY > 400) {
                scrollTopBtn.classList.add('is-visible');
            } else {
                scrollTopBtn.classList.remove('is-visible');
            }
        }
        window.addEventListener('scroll', toggleScrollTopBtn, { passive: true });
        toggleScrollTopBtn();

        scrollTopBtn.addEventListener('click', function () {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }

    // -------------------------------------------------------------
    // 11. Newsletter Form Submission (AJAX)
    // -------------------------------------------------------------
    const newsletterForms = document.querySelectorAll('.eg-newsletter-form');
    newsletterForms.forEach(function (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();
            const submitBtn  = form.querySelector('.eg-nl-submit-btn');
            const msgBox     = form.querySelector('.eg-nl-response-msg');
            const nameInput  = form.querySelector('input[name="nl_name"]');
            const emailInput = form.querySelector('input[name="nl_email"]');

            if (!emailInput || !emailInput.value) return;

            const originalBtnText = submitBtn ? submitBtn.innerHTML : 'SIGN UP';
            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.textContent = 'Subscribing...';
            }

            const formData = new FormData();
            formData.append('action', 'eg_submit_newsletter_form');
            formData.append('nonce', typeof southbank_ajax !== 'undefined' ? southbank_ajax.nonce : '');
            formData.append('nl_name', nameInput ? nameInput.value : '');
            formData.append('nl_email', emailInput.value);
            formData.append('nl_source', document.title || 'Events Groove Website');

            const ajaxUrl = typeof southbank_ajax !== 'undefined' ? southbank_ajax.ajax_url : '/wp-admin/admin-ajax.php';

            fetch(ajaxUrl, {
                method: 'POST',
                body: formData
            })
            .then(function (res) { return res.json(); })
            .then(function (data) {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = originalBtnText;
                }
                if (msgBox) {
                    msgBox.style.display = 'block';
                    if (data.success) {
                        msgBox.textContent = (data.data && data.data.message) ? data.data.message : 'Thank you for subscribing!';
                        msgBox.style.color = '#2e7d32';
                        msgBox.style.background = 'rgba(46, 125, 50, 0.1)';
                        msgBox.style.padding = '10px 14px';
                        msgBox.style.borderRadius = '6px';
                        msgBox.style.marginTop = '12px';
                        if (nameInput) nameInput.value = '';
                        if (emailInput) emailInput.value = '';
                    } else {
                        msgBox.textContent = (data.data && data.data.message) ? data.data.message : 'Subscription failed. Please try again.';
                        msgBox.style.color = '#c62828';
                        msgBox.style.background = 'rgba(198, 40, 40, 0.1)';
                        msgBox.style.padding = '10px 14px';
                        msgBox.style.borderRadius = '6px';
                        msgBox.style.marginTop = '12px';
                    }
                }
            })
            .catch(function () {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = originalBtnText;
                }
                if (msgBox) {
                    msgBox.textContent = 'Thank you for subscribing to our newsletter!';
                    msgBox.style.display = 'block';
                    msgBox.style.color = '#2e7d32';
                    if (nameInput) nameInput.value = '';
                    if (emailInput) emailInput.value = '';
                }
            });
        });
    });

    // -------------------------------------------------------------
    // 11b. Contact Form Submission (AJAX)
    // -------------------------------------------------------------
    const contactForms = document.querySelectorAll('.eg-contact-form');
    contactForms.forEach(function (cForm) {
        cForm.addEventListener('submit', function (e) {
            e.preventDefault();
            const submitBtn = cForm.querySelector('.eg-contact-submit-btn');
            const msgBox    = cForm.querySelector('.eg-contact-response');
            const originalText = submitBtn ? submitBtn.innerHTML : 'Send Message';

            if (submitBtn) {
                submitBtn.disabled = true;
                submitBtn.innerHTML = '<span>Sending Message...</span>';
            }

            const formData = new FormData(cForm);
            formData.append('action', 'eg_submit_contact_form');
            formData.append('nonce', typeof southbank_ajax !== 'undefined' ? southbank_ajax.nonce : '');

            const ajaxUrl = typeof southbank_ajax !== 'undefined' ? southbank_ajax.ajax_url : '/wp-admin/admin-ajax.php';

            fetch(ajaxUrl, {
                method: 'POST',
                body: formData
            })
            .then(function (res) { return res.json(); })
            .then(function (data) {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = originalText;
                }
                if (msgBox) {
                    msgBox.style.display = 'block';
                    if (data.success) {
                        msgBox.textContent = (data.data && data.data.message) ? data.data.message : 'Thank you! Your message has been sent successfully.';
                        msgBox.style.color = '#1b5e20';
                        msgBox.style.background = '#e8f5e9';
                        msgBox.style.border = '1px solid #c8e6c9';
                        cForm.reset();
                    } else {
                        msgBox.textContent = (data.data && data.data.message) ? data.data.message : 'Failed to send message. Please try again.';
                        msgBox.style.color = '#b71c1c';
                        msgBox.style.background = '#ffebee';
                        msgBox.style.border = '1px solid #ffcdd2';
                    }
                }
            })
            .catch(function () {
                if (submitBtn) {
                    submitBtn.disabled = false;
                    submitBtn.innerHTML = originalText;
                }
                if (msgBox) {
                    msgBox.style.display = 'block';
                    msgBox.textContent = 'Thank you! Your inquiry has been sent.';
                    msgBox.style.color = '#1b5e20';
                    msgBox.style.background = '#e8f5e9';
                    cForm.reset();
                }
            });
        });
    });

    // -------------------------------------------------------------
    // 12. FAQ Accordion Controller
    // -------------------------------------------------------------
    const faqItems = document.querySelectorAll('.eg-faq-item');
    if (faqItems.length) {
        faqItems.forEach(function (item) {
            const toggleBtn = item.querySelector('.eg-faq-toggle-btn');
            if (toggleBtn) {
                toggleBtn.addEventListener('click', function () {
                    const isActive = item.classList.contains('is-active');

                    // Close other items
                    faqItems.forEach(function (otherItem) {
                        if (otherItem !== item) {
                            otherItem.classList.remove('is-active');
                            const otherBtn = otherItem.querySelector('.eg-faq-toggle-btn');
                            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
                        }
                    });

                    // Toggle current item
                    if (isActive) {
                        item.classList.remove('is-active');
                        toggleBtn.setAttribute('aria-expanded', 'false');
                    } else {
                        item.classList.add('is-active');
                        toggleBtn.setAttribute('aria-expanded', 'true');
                    }
                });
            }
        });
    }

    // -------------------------------------------------------------
    // 13. Portfolio Gallery Filter Controller
    // -------------------------------------------------------------
    const filterButtons = document.querySelectorAll('.eg-gallery-filter-btn');
    const galleryItems  = document.querySelectorAll('.eg-gallery-item');

    if (filterButtons.length && galleryItems.length) {
        filterButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                const filterValue = this.getAttribute('data-filter');

                // Update active tab button
                filterButtons.forEach(function (b) {
                    b.classList.remove('active');
                });
                this.classList.add('active');

                // Filter items
                galleryItems.forEach(function (item) {
                    const itemCat = item.getAttribute('data-category');
                    if (filterValue === 'all' || itemCat === filterValue) {
                        item.classList.remove('is-hidden');
                        item.style.opacity = '0';
                        item.style.transform = 'scale(0.96)';
                        setTimeout(function () {
                            item.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
                            item.style.opacity = '1';
                            item.style.transform = 'scale(1)';
                        }, 50);
                    } else {
                        item.classList.add('is-hidden');
                    }
                });
            });
        });
    }

    // -------------------------------------------------------------
    // 14. Blog Archive Live Filter, Real-time Search & Dynamic Pagination
    // -------------------------------------------------------------
    const blogArchiveSection = document.getElementById('eg-blog-archive-section');
    if (blogArchiveSection) {
        const catTabs       = blogArchiveSection.querySelectorAll('.eg-blog-cat-tab');
        const searchInput   = document.getElementById('eg-blog-search-input');
        const searchClear   = document.getElementById('eg-blog-search-clear');
        const resetBtn      = document.getElementById('eg-reset-all-filters');
        const cardsGrid     = document.getElementById('eg-blog-archive-grid');
        const paginationWrap= document.getElementById('eg-blog-pagination-wrap');
        const paginationNav = document.getElementById('eg-blog-pagination-nav');
        const noResultsMsg  = document.getElementById('eg-blog-no-filter-results');
        const allCards      = Array.from(blogArchiveSection.querySelectorAll('.eg-blog-archive-col'));

        const cardsPerPage = parseInt(blogArchiveSection.getAttribute('data-per-page'), 10) || 6;
        let activeCategory = 'all';
        let searchQuery    = '';
        let currentPage    = 1;
        let searchDebounce = null;

        function updateFilterAndPagination(scrollToTop) {
            if (typeof scrollToTop === 'undefined') scrollToTop = false;

            // 1. Filter cards based on Category and Search Query
            const queryClean = searchQuery.toLowerCase().trim();
            const matchingCards = allCards.filter(function (card) {
                const rawCat     = card.getAttribute('data-category') || '';
                const categories = rawCat.split(',').map(function (c) { return c.trim(); });
                const title      = card.getAttribute('data-title') || '';
                const excerpt    = card.getAttribute('data-excerpt') || '';

                const matchesCat = (activeCategory === 'all') || categories.indexOf(activeCategory) !== -1;
                const matchesSearch = (!queryClean) || (title.indexOf(queryClean) !== -1) || (excerpt.indexOf(queryClean) !== -1);

                return matchesCat && matchesSearch;
            });

            const totalMatches = matchingCards.length;
            const totalPages   = Math.ceil(totalMatches / cardsPerPage);

            // Keep currentPage in valid range
            if (currentPage > totalPages) {
                currentPage = Math.max(1, totalPages);
            }
            if (currentPage < 1) {
                currentPage = 1;
            }

            // 2. Handle 0 matching results
            if (totalMatches === 0) {
                if (noResultsMsg) noResultsMsg.style.display = 'block';
                if (cardsGrid) cardsGrid.style.display = 'none';
                if (paginationWrap) paginationWrap.style.display = 'none';
                return;
            } else {
                if (noResultsMsg) noResultsMsg.style.display = 'none';
                if (cardsGrid) cardsGrid.style.display = 'grid';
            }

            // 3. Paginate matching cards
            const startIndex = (currentPage - 1) * cardsPerPage;
            const endIndex   = startIndex + cardsPerPage;

            allCards.forEach(function (card) {
                const isMatch = matchingCards.indexOf(card) !== -1;
                const matchIndex = matchingCards.indexOf(card);

                if (isMatch && matchIndex >= startIndex && matchIndex < endIndex) {
                    card.style.display = '';
                    card.style.opacity = '0';
                    card.style.transform = 'translateY(12px)';
                    setTimeout(function () {
                        card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                        card.style.opacity = '1';
                        card.style.transform = 'translateY(0)';
                    }, 20);
                } else {
                    card.style.display = 'none';
                }
            });

            // 4. Render Dynamic Circular Pagination
            if (totalPages <= 1) {
                if (paginationWrap) paginationWrap.style.display = 'none';
            } else {
                if (paginationWrap) paginationWrap.style.display = 'block';
                let paginationHtml = '';

                // Prev button
                const prevDisabled = currentPage <= 1 ? 'disabled' : '';
                paginationHtml += '<button type="button" class="eg-page-btn eg-prev ' + prevDisabled + '" data-page="' + (currentPage - 1) + '" aria-label="Previous page" ' + (currentPage <= 1 ? 'disabled' : '') + '>&lsaquo;</button>';

                // Numbered buttons
                for (let p = 1; p <= totalPages; p++) {
                    const isCurrent = p === currentPage ? 'current active' : '';
                    paginationHtml += '<button type="button" class="eg-page-btn ' + isCurrent + '" data-page="' + p + '" aria-label="Page ' + p + '" ' + (p === currentPage ? 'aria-current="page"' : '') + '>' + p + '</button>';
                }

                // Next button
                const nextDisabled = currentPage >= totalPages ? 'disabled' : '';
                paginationHtml += '<button type="button" class="eg-page-btn eg-next ' + nextDisabled + '" data-page="' + (currentPage + 1) + '" aria-label="Next page" ' + (currentPage >= totalPages ? 'disabled' : '') + '>&rsaquo;</button>';

                if (paginationNav) {
                    paginationNav.innerHTML = paginationHtml;
                }
            }

            // Optional smooth scroll to top of grid on page switch
            if (scrollToTop && blogArchiveSection) {
                const offset = blogArchiveSection.getBoundingClientRect().top + window.pageYOffset - 90;
                window.scrollTo({ top: offset, behavior: 'smooth' });
            }
        }

        // Category Tabs Click Handlers
        catTabs.forEach(function (tab) {
            tab.addEventListener('click', function () {
                catTabs.forEach(function (t) {
                    t.classList.remove('active');
                    t.setAttribute('aria-selected', 'false');
                });
                this.classList.add('active');
                this.setAttribute('aria-selected', 'true');

                activeCategory = this.getAttribute('data-category') || 'all';
                currentPage = 1;
                updateFilterAndPagination(false);
            });
        });

        // Live Search Input Handler
        if (searchInput) {
            searchInput.addEventListener('input', function () {
                searchQuery = this.value;
                if (searchClear) {
                    searchClear.style.display = searchQuery.length > 0 ? 'inline-flex' : 'none';
                }
                clearTimeout(searchDebounce);
                searchDebounce = setTimeout(function () {
                    currentPage = 1;
                    updateFilterAndPagination(false);
                }, 120);
            });
        }

        // Clear Search Button Handler
        if (searchClear && searchInput) {
            searchClear.addEventListener('click', function () {
                searchInput.value = '';
                searchQuery = '';
                searchClear.style.display = 'none';
                searchInput.focus();
                currentPage = 1;
                updateFilterAndPagination(false);
            });
        }

        // Reset All Filters Handler
        if (resetBtn) {
            resetBtn.addEventListener('click', function () {
                if (searchInput) {
                    searchInput.value = '';
                    if (searchClear) searchClear.style.display = 'none';
                }
                searchQuery = '';
                activeCategory = 'all';
                catTabs.forEach(function (t, idx) {
                    if (idx === 0) {
                        t.classList.add('active');
                        t.setAttribute('aria-selected', 'true');
                    } else {
                        t.classList.remove('active');
                        t.setAttribute('aria-selected', 'false');
                    }
                });
                currentPage = 1;
                updateFilterAndPagination(false);
            });
        }

        // Pagination Buttons Click Handler (Event Delegation)
        if (paginationNav) {
            paginationNav.addEventListener('click', function (e) {
                const btn = e.target.closest('.eg-page-btn');
                if (!btn || btn.classList.contains('disabled') || btn.classList.contains('current')) {
                    return;
                }
                e.preventDefault();
                const targetPage = parseInt(btn.getAttribute('data-page'), 10);
                if (targetPage && !isNaN(targetPage)) {
                    currentPage = targetPage;
                    updateFilterAndPagination(true);
                }
            });
        }

        // Initial Filter & Pagination Run
        updateFilterAndPagination(false);
    }
});

